import { Box } from '@mui/material';
import PolarisIcon from '../../../_common/PolarisIcon';
import { useAppSelector } from '@/redux/hooks';
  import { selectCanWriteFileManager } from '@/redux/selectors/authSelectors';

interface FileItemIconProps {
  hover: boolean;
  selected: boolean;
}

const FileItemIcon = ({ hover, selected }: FileItemIconProps) => {
  const canWriteFileManager = useAppSelector(selectCanWriteFileManager);

  return (
    <Box sx={{ color: !hover && !selected ? 'text.primary' : 'secondary.main', display: 'inline-flex', width: 23, justifyContent: 'center' }}>
      {!canWriteFileManager || (!hover && !selected) ? (
        <PolarisIcon icon="file_filled" height={20} />
      ) : (
        <PolarisIcon icon={selected ? 'checkbox_checked' : 'checkbox_unchecked'} height={23} />
      )}
    </Box>
  );
};

export default FileItemIcon;
